import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 全局数据源
import { ListStore } from '../../store';
// 数字转中文
import nzhcn from 'nzh/cn';
// 拉端
import { callApp } from '@ifeng-fe/callapp';
import { setQuery } from '@src/utils/url';
// 跳转
import { groundsDispatch } from '@src/utils/app';
// 统计
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import Observer from '@researchgate/react-intersection-observer';
import { getStyle } from '@src/utils';

// 相关推荐
import Relseries from './Relseries';
import { Grounds } from '@ifeng-fe/client_grounds';
const DramaSeries = ({ content, openDramaList, dramaIndex, onChangeDramaIndex }) => {
    const {
        params: { id },
    } = content;
    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { currentVideo, dramaSeries, positive, gagsList, gags, related } = listStates;

    const listWrapRef = useRef();
    const listScrollRef = useRef();
    // 获取列表高度
    const [listHeight, setListHeight] = useState();
    // 0选集1相关推荐
    const [tab, setTab] = useState(0);
    // 渲染列表
    const [renderList, setRenderList] = useState(positive);
    // 曝光选集
    const handleObserverChangePositive = (entry, unobserve, index) => {
        const { isIntersecting } = entry;

        if (isIntersecting) {
            const { base62Id } = positive[index];

            Grounds.expose({
                behavior: 'pageinfo',
                // environment: 'client',
                id: `video_${base62Id}`,
                rnum: `${index}`,
                reftype: 'editor|||||||', // 不加encodeURL
                ch: `phmovie_${dramaSeries.base62Id}`,
                src: '',
                showtype: 'choiceepisode',
                pagetype: 'video',
            });
            unobserve();
        }
    };

    // 切换索引
    useEffect(
        () => {
            if (currentVideo.videoPlayUrl) {
                const index = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

                // 当前视频为正片
                if (index > -1) {
                    onChangeDramaIndex(index);

                    return;
                } else {
                    // 当前视频为花絮
                    // 获取对应正片
                    for (let i = 0; i < gagsList.length; i++) {
                        const gags = gagsList[i];

                        for (let j = 0; j < gags.length; j++) {
                            if (gags[j].base62Id === currentVideo.base62Id) {
                                onChangeDramaIndex(i);

                                return;
                            }
                        }
                    }
                }
            }
        },
        [currentVideo],
    );

    // 选集模块
    const handleCollect = () => {
        setTab(0);
        setRenderList(positive);
    };
    // 相关推荐模块
    const handleRecommond = () => {
        setTab(1);

        setRenderList(related);
    };

    // 切换选集
    const handleCollectNum = (item, index) => {
        // if (!window.grounds) {
        //     console.log('拉端');

        //     const url = window.location.href;

        //     callApp({
        //         docType: 'web',
        //         pid: url,
        //         kind: 'inter_da01',
        //         noKindFrom: 1,
        //         download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1512057577113',
        //         downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8927',
        //     });

        //     return;
        // }
        onChangeDramaIndex(index);
        const gags = gagsList.find((item, i) => i === index);

        console.log('切换选集', item);
        changeListStates({
            currentVideo: item,
            gags,
        });

        // 主动点击统计
        Grounds.pageStat({
            behavior: 'page',
            id: `video_${item.base62Id}`,
            type: 'video',
            ref: `phmovie_${dramaSeries.base62Id}`,
            reftype: 'editor|||||||',
            rnum: index,
            showtype: 'choiceepisode',
            pagetag: '', // 手动clear
        });

        // sendPositivePage(item.base62Id, dramaSeries.base62Id, index);
    };

    // 列表滚动中间
    const rollListLeft = autoIndex => {
        const index = autoIndex ?? dramaIndex; // autoInde联播/tagIndex点击
        const listScroll = listScrollRef.current;
        const listChildNodes = listScroll.childNodes[0].childNodes;
        const current = listChildNodes[index];

        // 计算paddingLeft;
        const paddingLeft = parseFloat(getStyle(listScroll, 'paddingLeft'), 10);
        const listMiddle = Math.floor(parseInt(listScroll.clientWidth, 10) / 2);
        const tagMiddle = current.offsetWidth / 2;

        // 排除第一项;

        if (index.toString() === '0') {
            return (listScroll.scrollLeft = 0);
        }

        if (current.offsetLeft + tagMiddle > listMiddle) {
            listScroll.scrollLeft = Math.floor(current.offsetLeft - listMiddle + current.offsetWidth / 2);
        } else {
            listScroll.scrollLeft = Math.floor(listMiddle - current.offsetLeft - current.offsetWidth / 2);
        }
    };

    // 手动滚
    useEffect(
        () => {
            if (dramaIndex && listScrollRef.current) {
                rollListLeft();
            }
        },
        [dramaIndex, listScrollRef],
    );
    // 自动滚
    useEffect(
        () => {
            if (currentVideo.videoPlayUrl) {
                const autoIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);
                // 当前视频为正片

                if (autoIndex > -1) {
                    rollListLeft(autoIndex);
                }
            }
        },
        [currentVideo],
    );

    useEffect(
        () => {
            if (listWrapRef.current && listScrollRef.current) {
                // const listWrapDom = listWrapRef.current;
                // const listScrollDom = listScrollRef.current;
                //
                // // 固定列表高度
                // setListHeight(listWrapDom.offsetHeight);
                // 隐藏滚动条
                // listScrollDom.style.paddingBottom = `${listWrapDom.offsetHeight + 50}px`;
            }
        },
        [listWrapRef, listScrollRef],
    );

    const handleTotalClick = () => {
        if (!window.grounds) {
            return;
        }

        if (renderList.length && renderList.length > 5) {
            openDramaList(renderList);
        }
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.tabWrap}>
                <div className={styles.tab}>
                    <div className={styles.collect} onClick={handleCollect}>
                        选集
                    </div>
                    {/* <div className={styles.line} /> */}
                </div>

                <div className={styles.total} onClick={handleTotalClick}>
                    {renderList?.length && tab === 0
                        ? `${renderList.length === 1 ? '全' : '共'}${renderList.length}集`
                        : null}
                    {window.grounds &&
                        renderList.length > 5 && (
                            <div className={styles.more}>
                                <svg
                                    width="9px"
                                    height="5px"
                                    viewBox="0 0 9 5"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink">
                                    <title>3</title>
                                    <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <path
                                            d="M1.75104076,0.290380592 L4.47328932,3.01328932 L7.19576298,0.290380592 C7.4886562,-0.00251262658 7.96352993,-0.00251262658 8.25642315,0.290380592 C8.54931637,0.583273811 8.54931637,1.05814755 8.25642315,1.35104076 L5.07444264,4.53302128 C4.91007424,4.69738968 4.68839419,4.76951637 4.47372781,4.74940135 C4.25910028,4.76974084 4.03698553,4.6976457 3.87236111,4.53302128 L0.690380592,1.35104076 C0.397487373,1.05814755 0.397487373,0.583273811 0.690380592,0.290380592 C0.983273811,-0.00251262658 1.45814755,-0.00251262658 1.75104076,0.290380592 Z"
                                            id="3"
                                            fill="#4D4D4D"
                                        />
                                    </g>
                                </svg>
                            </div>
                        )}
                </div>
            </div>
            {/* 0选集1相关推荐 */}
            <div
                className={styles.listWrap}
                id="listWrapPositive"
                ref={listWrapRef}
                // 固定列表高度
                style={{ maxHeight: `${listHeight}px` }}>
                <div className={styles.listScroll} ref={listScrollRef}>
                    <div className={styles.listContent}>
                        {renderList &&
                            renderList.map((item, index) => {
                                const { title, title2, extText } = item;

                                return (
                                    <Observer
                                        onChange={(entry, unobserve) =>
                                            handleObserverChangePositive(entry, unobserve, index)
                                        }
                                        key={index}>
                                        <div
                                            className={`${styles.itemWrap} ${
                                                dramaIndex === index ? styles.current : ''
                                            }`}
                                            onClick={() => handleCollectNum(item, index)}>
                                            {/* {!window.grounds && currentVideo.base62Id !== item.base62Id ? (
                                                <div className={styles.groundsTitle}>APP内播放</div>
                                            ) : null} */}
                                            {extText ? (
                                                <div className={styles.itemTitle}>{extText}</div>
                                            ) : (
                                                <div className={styles.itemTitle}>{`${
                                                    renderList.length === 1 ? '全' : '第'
                                                }${nzhcn.encodeS(index + 1)}集`}</div>
                                            )}

                                            <div className={styles.itemContent}>{title2 ? title2 : title}</div>
                                        </div>
                                    </Observer>
                                );
                            })}
                    </div>
                </div>
            </div>
            {related &&
                related.length > 0 && (
                    <div className={styles.listWrapRelated} id="listWrapRelated">
                        <div className={styles.listScrollRelated}>
                            <div className={styles.listContentRelated}>
                                {related &&
                                    related.map((item, index) => {
                                        return <Relseries key={index} content={{ item, index, id }} />;
                                    })}
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
};

DramaSeries.propTypes = {
    content: PropTypes.object,
    openDramaList: PropTypes.func,
    dramaIndex: PropTypes.number,
    onChangeDramaIndex: PropTypes.func,
};

export default errorBoundary(DramaSeries);
